import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import qs from 'querystring';
const renderScriptOpenWrapUrl = (openWrapUrl, baseUrl) => {
  const profileVersionId = qs.parse(baseUrl.search.slice(1)).pwtv;
  const pwtVersionPath = profileVersionId ? '/' + profileVersionId : '';
  const currentOpenWrapUrl = `${openWrapUrl}${pwtVersionPath}/pwt.js`;
  return /*#__PURE__*/_jsx("script", {
    type: "text/javascript",
    src: currentOpenWrapUrl,
    defer: true
  });
};
const renderPrebid = prebidPath => /*#__PURE__*/_jsx("script", {
  type: "text/javascript",
  src: prebidPath,
  defer: true
});
const renderGPT = gptPath => /*#__PURE__*/_jsx("script", {
  type: "text/javascript",
  src: gptPath,
  defer: true
});
function AdLibrariesHeaders(_ref) {
  let {
    reqUrl,
    excludeHeaderBidding = false,
    openWrapUrl,
    loadPrebid = false,
    prebidPath = '//www.autotrader.com/0_00_0000/resources/js/bundle/prebid.js'
  } = _ref;
  const baseUrl = new URL(reqUrl);
  const gptScriptSrc = '//securepubads.g.doubleclick.net/tag/js/gpt.js';
  return /*#__PURE__*/React.createElement(React.Fragment, null, !excludeHeaderBidding && openWrapUrl && renderScriptOpenWrapUrl(openWrapUrl, baseUrl), renderGPT(gptScriptSrc), !excludeHeaderBidding && loadPrebid && renderPrebid(prebidPath));
}
AdLibrariesHeaders.propTypes = {
  reqUrl: PropTypes.string,
  excludeHeaderBidding: PropTypes.bool,
  /**
   * If present, the URL will be loaded as a script before the gpt library is loaded.
   */
  openWrapUrl: PropTypes.string,
  /**
   * If true, the prebid library will be added to the head
   */
  loadPrebid: PropTypes.bool,
  /**
   * Path to prebid library
   */
  prebidPath: PropTypes.string
};
export default AdLibrariesHeaders;